import { render } from "./BoardDetail.vue?vue&type=template&id=360caa80"
import script from "./BoardDetail.vue?vue&type=script&lang=js"
export * from "./BoardDetail.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./BoardDetail.vue?vue&type=style&index=0&id=360caa80&module=true&lang=css"
cssModules["$style"] = style0

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__